import React, { useMemo } from 'react';
import { Url } from '@wix/da-url';
import { BiLoggerContextProvider } from '../../../biLogger';
import SimpleDeviationGridBlock from '../../_partials/SimpleDeviationGridBlock';
export var Popular = function (_a) {
    var popular = _a.popular, parentDeviation = _a.parentDeviation, isLoading = _a.isLoading;
    var authorUuid = parentDeviation.author && parentDeviation.author.useridUuid;
    var seeAll = useMemo(function () { return ({
        href: Url.browseHomeLink(),
        biData: {
            creatorid: authorUuid,
        },
    }); }, [authorUuid]);
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: 'popular' } },
        React.createElement(SimpleDeviationGridBlock, { streamKey: "popular", parentDeviation: parentDeviation, deviations: popular, seeAll: seeAll, isLoading: isLoading })));
};
Popular.displayName = 'Popular';
export default Popular;
//# sourceMappingURL=Popular.js.map